import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Building2, User, MapPin, Mail, Globe, FileText } from 'lucide-react';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] noise-overlay">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 glass">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="font-bold text-xl tracking-tight text-white flex items-center gap-2">
              WrapViz
            </Link>
            <Link to="/" className="text-sm text-zinc-400 hover:text-white transition-colors flex items-center gap-2">
              <ArrowLeft size={16} />
              Back to Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="pt-24 pb-16 px-6 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-black tracking-tighter text-white mb-8">Impressum</h1>
            
            <div className="bg-zinc-900/50 border border-zinc-800 p-8 space-y-8">
              {/* Company Info */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#FF3399]/10 flex items-center justify-center">
                    <Building2 className="w-5 h-5 text-[#FF3399]" />
                  </div>
                  <h2 className="text-xl font-bold text-white">Unternehmen</h2>
                </div>
                <p className="text-lg text-white font-medium mb-1">Embermotors UG</p>
                <p className="text-zinc-400">(haftungsbeschränkt)</p>
              </div>

              {/* Managing Director */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#FF3399]/10 flex items-center justify-center">
                    <User className="w-5 h-5 text-[#FF3399]" />
                  </div>
                  <h2 className="text-xl font-bold text-white">Geschäftsführer</h2>
                </div>
                <p className="text-zinc-300">Mehmet Altan Koryürek</p>
              </div>

              {/* Address */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#FF3399]/10 flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-[#FF3399]" />
                  </div>
                  <h2 className="text-xl font-bold text-white">Adresse</h2>
                </div>
                <p className="text-zinc-300">Bürgermeister-Mahr Straße 32</p>
                <p className="text-zinc-300">63179 Obertshausen</p>
                <p className="text-zinc-300">Deutschland</p>
              </div>

              {/* Contact */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#FF3399]/10 flex items-center justify-center">
                    <Mail className="w-5 h-5 text-[#FF3399]" />
                  </div>
                  <h2 className="text-xl font-bold text-white">Kontakt</h2>
                </div>
                <p className="text-zinc-300">
                  E-Mail:{' '}
                  <a href="mailto:Embermotors@gmail.com" className="text-[#FF3399] hover:underline">
                    Embermotors@gmail.com
                  </a>
                </p>
                <p className="text-zinc-300 mt-2">
                  Website:{' '}
                  <a href="https://Embermotors.de" target="_blank" rel="noopener noreferrer" className="text-[#FF3399] hover:underline">
                    Embermotors.de
                  </a>
                </p>
              </div>

              {/* Registration */}
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-[#FF3399]/10 flex items-center justify-center">
                    <FileText className="w-5 h-5 text-[#FF3399]" />
                  </div>
                  <h2 className="text-xl font-bold text-white">Registereintrag</h2>
                </div>
                <p className="text-zinc-300">Registergericht: Offenbach am Main</p>
                <p className="text-zinc-300">Handelsregisternummer: HRB 577178</p>
              </div>

              {/* Disclaimer */}
              <div className="pt-6 border-t border-zinc-800">
                <h3 className="text-lg font-bold text-white mb-3">Haftungsausschluss</h3>
                <p className="text-zinc-400 text-sm leading-relaxed">
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
                  Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
                </p>
              </div>
            </div>

            {/* Back Link */}
            <div className="mt-8 text-center">
              <Link 
                to="/" 
                className="inline-flex items-center gap-2 text-zinc-500 hover:text-white transition-colors"
              >
                <ArrowLeft size={16} />
                Zurück zur Startseite
              </Link>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 border-t border-zinc-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <p className="text-zinc-600 text-sm">
            © {new Date().getFullYear()} WrapViz by Embermotors UG. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ImpressumPage;
